import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import { Dialog, DialogContent, DialogTitle, IconButton, Menu } from "@mui/material";
import { Close, History, Report } from "@mui/icons-material";
import { MdReportGmailerrorred } from "react-icons/md";
import PartnerWorklogs from "components/Partner/PartnerWorklogs";
import BasicMenu from "helpers/menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";

function Partners({ location, SetSelectedMenu }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [list, setList] = useState([]);
    const [id, setId] = useState();

    const [count, setCount] = useState(0);

    const [deleteOpen, setDeleteOpen] = useState(false);
    const [worklogReportOpen, setWorklogReportOpen] = useState(false);

    const [selectedPartner, setSelectedPartner] = useState(null);


      const [anchorEl, setAnchorEl] = React.useState(null);
      const openMenu = Boolean(anchorEl);
      const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };

    const history = useHistory();

    useEffect(() => {
        SetSelectedMenu({
            menu: "partner",
            title: "Partners Management",
        });
    }, []);

    const columns = [
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "representative",
            label: "Representative",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "address",
            label: "Address",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "phone",
            label: "Phone",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "projects",
            label: "Projects",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "totalAmount",
            label: "Amount Allocated",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{
                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</span>
                ),
            },
        },
        {
            name: "receivedAmount",
            label: "Spent",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{
                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</span>
                )
            },
        },
        {
            name: "id",
            label: "Balance",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const balance = list.find((x) => x.id === value)?.totalAmount - list.find((x) => x.id === value)?.receivedAmount;
                   return  <span className="text-custom-blue text-xs ">{
                    balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</span>
                }
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) =>  <BasicMenu onDetails={() => history.push(`/admin/partner-projects/${v}`, { partner: list.find((x) => x.id === v)}) } onDelete={() => {
                    setDeleteOpen(true);
                    setId(v);
                }} onEdit={() => {
                                                setId(v);
                            setValue({
                                name: list.find((x) => x.id === v).name,
                                representative: list.find((x) => x.id === v).representative,
                                address: list.find((x) => x.id === v).address,
                                email: list.find((x) => x.id === v).email,
                                phone: list.find((x) => x.id === v).phone,

                         
                            });
                            setOpen(2);
                 }} 
                 extra={[
                    {
                        label: "Worklogs Report",
                        icon: <History />,
                        onClick: () => {
                                                     setWorklogReportOpen(true);
                            setSelectedPartner(list.find((x) => x.id === v));
                        }
                    },
                ]}
                 
                 />
            },
        },
    ];

    // worklog report dialog  
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">
            <Dialog className="w-full" open={worklogReportOpen} onClose={() => setWorklogReportOpen(false)} sx={{
                "& .MuiDialog-paper": {
                    width: "80%",
                    maxWidth: "80%",
                    height: "80%",
                    maxHeight: "80%",   
                },
            }}>
                <DialogTitle>
                    <div className="flex items-center justify-between">
                        <span className="text-lg font-bold">Worklog Report for {selectedPartner?.name}</span>
                   
                             <IconButton onClick={() => setWorklogReportOpen(false)}>
                                        <img
                                          src={require("assets/icons/close.svg").default}
                                          alt={"close"}
                                        />
                                      </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent className="w-full">
                    <PartnerWorklogs partner={selectedPartner}/>
                </DialogContent>
            </Dialog>

            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/partner/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/partner/create" : `/api/partner/update/${id}`}
                title={open === 1 ? "Create New Partner" : "Edit Partner"}
                fields={[
                    {
                        name: "name",
                        label: "Partner name",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "representative",
                        label: "Representative",
                        value: value["representative"],
                        required: false,
                        type: 'text',
                        setValue: (val) => setValue0("representative", val),
                    },
                    {
                        name: "address",
                        label: "Address",
                        type: "text",
                        value: value["address"],
                        required: true,
                        setValue: (val) => setValue0("address", val),
                    },
                    {
                        name: "email",
                        label: "Email",
                        type: "text",
                        value: value["email"],
                        required: true,
                        setValue: (val) => setValue0("email", val),
                    },
                    {
                        name: "phone",
                        label: "Phone",
                        type: "text",
                        value: value["phone"],
                        required: true,
                        setValue: (val) => setValue0("phone", val),
                    },


                ]}
            />
            <DatatableComponent

                onAddNew={() => setOpen(1)}
                processData={(data) => {
                    setList(data.data);
                    return data;
                }}
                
                onRowSelectionChange={(list) => {


                }
                }
                onRowClick={(data, { rowIndex })=> {
                    const info = list[rowIndex];
                    history.push(`/admin/partner-projects/${info?.id}`, {partner: info});
                }}
                elevation={1}
                pdf={false}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                url={`/api/partner/list?count=${count}`}
                title={
                    "All Partner List"
                }
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Partners);
